/**
 * You can register functions here and use them in your everywhere
 */
const utils = {
  exampleFunc: function() {}
};

export default utils;
